<template>
  <highcharts class="hc col-12" :options="chartOptions" ref="chart"></highcharts>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
  histData: Object,
});

const chartOptions = ref({
  chart: {
    type: 'column',
  },
  title: {
    text: props.histData.title,
  },
  style: {
    fontFamily: 'Roboto',
    fontSize: '15px,',
  },
  subtitle: {
    text: '',
  },
  xAxis: {
    categories: props.histData.range,
    crosshair: true,
  },
  yAxis: {
    min: 0,
    title: {
      text: 'Count',
    },
  },
  tooltip: {
    headerFormat: '<span style="font-size:10px">{point.key} {series.name}</span><table>',
    pointFormat: '<tr><td style="color:{series.color};padding:0">Count: </td>'
      + '<td style="padding:2px"><b>{point.y}</b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  },
  plotOptions: {
    column: {
      pointPadding: 0,
      borderWidth: 1,
      groupPadding: 0,
      shadow: false,
      series: {
        borderColor: '#ffffff',

      },
    },
  },
  series: [{
    name: props.histData.measurement,
    data: props.histData.count,
    color: '#24B8FC',

  }],
});
</script>
